<template>
  <v-card>
    <v-card-title>
      <span>대출 현황</span>
    </v-card-title>
    <v-card-subtitle>
      <div class="top">
        <span>상환중 (총 {{ totalLoanCount }} 건)</span>
      </div>
      <div class="down">
        <strong>총 대출잔액 {{ totalLeftAmount | commaFormat }} 원</strong>
      </div>
    </v-card-subtitle>
    <v-card-actions>
      <MyMainNavigateButton button-text="대출 상환 내역보기" router-name="my/loans" />
    </v-card-actions>
  </v-card>
</template>
<script>
import LoanService from '@/service/loan/LoanService'

import MyMainNavigateButton from './MyMainNavigateButton.vue'

export default {
  components: {
    MyMainNavigateButton
  },
  data() {
    return {
      totalLeftAmount: 0,
      totalLoanCount: 0,
    }
  },
  async created() {
    await this.setMyLoanState()
  },
  computed: {
  },
  methods: {
    async setMyLoanState() {
      let data = await LoanService.getLoanOngoingForRepayment()
      let loan = data.filter((loan) => loan.status === 'executed')
      this.totalLeftAmount = loan.reduce(
        (accumulator, loan) => accumulator + loan.left_amount, 0
      )
      this.totalLoanCount = loan.length
    }
  },
}
</script>
<style lang="scss" scoped>
  .v-card {
    margin: 0 25px;
    margin-bottom: 20px;
    padding: 18px 25px;

    .v-card__title {
      margin-bottom: 12px;
      padding-left: 0 !important;

      span {
        font-weight: 900;
      }
    }
    .v-card__subtitle {
      color: #333333;
      padding-left: 0 !important;
      line-height: 25px;

      .top {
        span {
          font-size: 14px;
          font-weight: 900;
          color: #999999;
        }
      }
      .down {
        strong {
          font-size: 19px;
          font-weight: 700;
        }
      }
    }

    .v-card__actions {
      padding: 0;
    }
  }
</style>
